import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, TextField, Typography } from '@mui/material';

// Wizard step 3 — pipeline Name (AC-5/AC-7). The create call itself (POST) happens in
// the wizard container on submit of this step, not here — this component is presentation
// + Formik field wiring only, plus surfacing the inline create error (AC-7/RV-3: 400).
const NameStep = ({ values, errors, touched, setFieldValue, setFieldTouched, createError }) => (
  <Box>
    <Typography component='p' color='text.primary' fontSize={14} mb={2}>
      Pipeline name
      <Box component='span' ml={1} sx={{ color: 'error.main' }}>
        *
      </Box>
    </Typography>
    <TextField
      fullWidth
      value={values.Name ?? ''}
      placeholder='e.g. billing-svc-pipeline'
      error={touched?.Name && !!errors?.Name}
      helperText={touched?.Name ? errors?.Name : ''}
      onChange={(e) => {
        setFieldTouched('Name', true);
        setFieldValue('Name', e.target.value, true);
      }}
      inputProps={{ 'aria-label': 'Pipeline name' }}
    />

    {createError && (
      <Alert severity='error' sx={{ mt: 3 }} role='alert'>
        {createError}
      </Alert>
    )}
  </Box>
);

export default React.memo(NameStep);

NameStep.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  createError: PropTypes.string,
};
